import type { Locale } from 'date-fns';
import enUsLocale from 'date-fns/locale/en-US';

import { formatLong } from './formatLong';
import { localize } from './localize';

/**
 * @type {Locale}
 * @category Locales
 * @summary Somali locale.
 * @language Somali
 * @iso-639-2 som
 */
export const soLocale: Locale = {
  code: 'som',
  formatDistance: enUsLocale.formatDistance,
  formatLong,
  formatRelative: enUsLocale.formatRelative,
  localize,
  match: enUsLocale.match,
  options: {
    weekStartsOn: 6 /* Saturday */,
    firstWeekContainsDate: 1,
  },
};
